import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { AnimatePresence, motion } from "framer-motion";
import theme from "./styles/theme";
import GlobalStyles from "./styles/GlobalStyles";
import useScrollToTop from "./hooks/useScrollToTop";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import BottomBar from "./components/layout/BottomBar";
import NewsletterPopup from "./components/ui/NewsletterPopup";
import ScrollIndicator from "./components/ui/ScrollIndicator";
import HomePage from "./pages/HomePage";
import YachtsPage from "./pages/YachtsPage";
import YachtDetailPage from "./pages/YachtDetailPage";
import BrandsPage from "./pages/BrandsPage";
import BrandDetailsPage from "./pages/BrandDetailsPage";
import NewBuildingsPage from "./pages/NewBuildingsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ScrollToTop() {
  useScrollToTop();
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="popLayout">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
      >
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/yachts" element={<YachtsPage />} />
          <Route path="/yachts/:id" element={<YachtDetailPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/brands/:slug" element={<BrandDetailsPage />} />
          <Route path="/new-buildings" element={<NewBuildingsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <BrowserRouter>
        <ScrollToTop />
        <ScrollIndicator />
        <Navbar />
        <main>
          <AnimatedRoutes />
        </main>
        <Footer />
        <BottomBar />
        <NewsletterPopup />
      </BrowserRouter>
      <ToastContainer position="bottom-right" autoClose={4000} />
    </ThemeProvider>
  );
}

export default App;
